var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.storyPosts.length
    ? _c("div", { staticClass: "reporting-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("i", { staticClass: "material-icons section-icon" }, [
            _vm._v("web_stories"),
          ]),
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("dash.reporting.section.story-list.title"))),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "post-table" },
          [
            _c("div", { staticClass: "post-table__head" }, [
              _c(
                "span",
                {
                  staticClass: "col-header sortable",
                  class: _vm.sortClass("date"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("date")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.cap(_vm.$t("dash.reporting.pdf.listItem.date"))
                      )
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("date"))),
                  ]),
                ]
              ),
              _c("span", { staticClass: "col-header" }, [
                _vm._v(
                  _vm._s(
                    _vm.cap(_vm.$t("dash.reporting.pdf.listItem.publication"))
                  )
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "col-header sortable align-right",
                  class: _vm.sortClass("impressions"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("impressions")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.cap(_vm.$t("dash.reporting.impressions")))
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("impressions"))),
                  ]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "col-header sortable align-right",
                  class: _vm.sortClass("replies"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("replies")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.cap(_vm.$t("dash.reporting.replies")))
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("replies"))),
                  ]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "col-header sortable align-right",
                  class: _vm.sortClass("shares"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("shares")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.cap(_vm.$t("dash.reporting.share")))
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("shares"))),
                  ]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "col-header sortable align-right",
                  class: _vm.sortClass("interactions"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("interactions")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.cap(_vm.$t("dash.reporting.total_interactions"))
                      )
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("interactions"))),
                  ]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "col-header sortable align-right",
                  class: _vm.sortClass("profile_visits"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("profile_visits")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.cap(_vm.$t("dash.reporting.profile_visits")))
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("profile_visits"))),
                  ]),
                ]
              ),
              _c(
                "span",
                {
                  staticClass: "col-header sortable align-right",
                  class: _vm.sortClass("follows"),
                  on: {
                    click: function ($event) {
                      return _vm.onSort("follows")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.cap(_vm.$t("dash.reporting.follows")))
                  ),
                  _c("i", { staticClass: "material-icons sort-icon" }, [
                    _vm._v(_vm._s(_vm.sortIcon("follows"))),
                  ]),
                ]
              ),
            ]),
            _vm._l(_vm.paginatedPosts, function (post) {
              return _c(
                "div",
                {
                  key: post.id || post.post_id,
                  staticClass: "post-table__row",
                },
                [
                  _c("span", { staticClass: "cell-date" }, [
                    _vm._v(
                      _vm._s(_vm.fmtDate(post.created_time || post.timestamp))
                    ),
                  ]),
                  _c("div", { staticClass: "cell-post" }, [
                    _c("div", { staticClass: "post-thumb story-thumb" }, [
                      post.attachment_url
                        ? _c("img", {
                            attrs: { src: post.attachment_url, alt: "" },
                          })
                        : _c("i", { staticClass: "material-icons" }, [
                            _vm._v("crop_portrait"),
                          ]),
                    ]),
                    _c("p", { staticClass: "post-msg" }, [
                      _vm._v(_vm._s(post.message || post.caption || "—")),
                    ]),
                  ]),
                  _c("span", { staticClass: "cell-num" }, [
                    _vm._v(_vm._s(_vm.fmt(post.post_impressions))),
                  ]),
                  _c("span", { staticClass: "cell-num" }, [
                    _vm._v(_vm._s(_vm.fmt(post.replies))),
                  ]),
                  _c("span", { staticClass: "cell-num" }, [
                    _vm._v(_vm._s(_vm.fmt(post.shares))),
                  ]),
                  _c("span", { staticClass: "cell-num" }, [
                    _vm._v(_vm._s(_vm.fmt(post.total_interactions))),
                  ]),
                  _c("span", { staticClass: "cell-num" }, [
                    _vm._v(_vm._s(_vm.fmt(post.profile_visits))),
                  ]),
                  _c("span", { staticClass: "cell-num" }, [
                    _vm._v(_vm._s(_vm.fmt(post.follows))),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _vm.pageCount > 1
          ? _c("div", { staticClass: "pagination" }, [
              _c(
                "button",
                {
                  staticClass: "page-btn",
                  attrs: { disabled: _vm.currentPage === 1 },
                  on: {
                    click: function ($event) {
                      _vm.currentPage--
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_left"),
                  ]),
                ]
              ),
              _c("span", { staticClass: "page-info" }, [
                _vm._v(_vm._s(_vm.currentPage) + " / " + _vm._s(_vm.pageCount)),
              ]),
              _c(
                "button",
                {
                  staticClass: "page-btn",
                  attrs: { disabled: _vm.currentPage === _vm.pageCount },
                  on: {
                    click: function ($event) {
                      _vm.currentPage++
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_right"),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }